import { CompanyRole } from '../company_role_assignment/companyRoleAssignment';
import { StockLocationRole } from '../stock_location_role_assignment/stockLocationRoleAssignment';
import { CompanyEntity } from './entity';

export class EntityAuthorization<T extends CompanyEntity> {
  forCreate = (): CompanyRole | StockLocationRole => StockLocationRole.STOCK_LOCATION_VIEWER;
  forUpdate = (): CompanyRole | StockLocationRole => StockLocationRole.STOCK_LOCATION_VIEWER;
  forDelete = (): CompanyRole | StockLocationRole => StockLocationRole.STOCK_LOCATION_VIEWER;
  forGet = (): CompanyRole | StockLocationRole => StockLocationRole.STOCK_LOCATION_VIEWER;
}
